/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export default function(ranges, lowBound) {
  if (ranges.length > 0) {
    return lowBound + ranges.length - 1;
  }
  return lowBound + 1;
}
